{
  "chart": "患者カルテ",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "患者基本情報",
    "loading": "患者基本情報を読み込み中...",
    "loadError": "患者基本情報の読み込みに失敗しました。",
    "returnToDashboard": "ダッシュボードに戻る",
    "updatedSuccess": "患者基本情報を更新しました",
    "updateError": "患者基本情報の更新に失敗しました",
    "sections": {
      "personalInformation": "個人情報",
      "identification": "本人確認",
      "contactInformation": "連絡先",
      "address": "住所",
      "languageAndPreferences": "言語と希望",
      "specialFlags": "特別フラグ",
      "recordInformation": "記録情報"
    },
    "fields": {
      "fullName": "氏名",
      "alternativeName": "別名",
      "preferredName": "通称",
      "dateOfBirth": "生年月日",
      "birthTime": "出生時刻",
      "age": "年齢",
      "legalGender": "戸籍上の性別",
      "genderIdentity": "性自認",
      "sexAtBirth": "出生時の性別",
      "race": "人種",
      "ethnicity": "民族",
      "nationality": "国籍",
      "mrn": "MRN",
      "nationalIdType": "本人確認書類の種類",
      "nationalIdNumber": "本人確認書類番号",
      "passportNumber": "旅券番号",
      "passportCountry": "旅券発行国",
      "primaryPhone": "主電話番号",
      "mobilePhone": "携帯電話",
      "email": "メールアドレス",
      "preferredContactMethod": "希望連絡方法",
      "addressLine1": "住所 1 行目",
      "addressLine2": "住所 2 行目",
      "city": "市区町村",
      "stateProvince": "都道府県",
      "postalCode": "郵便番号",
      "country": "国",
      "primaryLanguage": "主言語",
      "secondaryLanguage": "副言語",
      "interpreterRequired": "通訳が必要",
      "vipStatus": "VIP 状態",
      "confidentialityLevel": "機密レベル",
      "medicalTourist": "医療渡航者",
      "homeCountry": "出身国",
      "status": "状態",
      "deceased": "死亡",
      "created": "作成日時",
      "lastModified": "最終更新",
      "passportOnFile": "パスポート保管済み",
      "organDonorStatus": "臓器提供意思"
    },
    "statusValues": {
      "active": "有効",
      "inactive": "無効"
    },
    "deceasedSummary": "はい（{{date}}）",
    "deceasedDateUnknown": "日付不明",
    "legalGender": {
      "label": "戸籍上の性別",
      "values": {
        "male": "男性",
        "female": "女性",
        "other": "その他",
        "unknown": "不明"
      },
      "selectPlaceholder": "性別を選択"
    },
    "sexAtBirth": {
      "label": "出生時の性別",
      "values": {
        "female": "女性",
        "male": "男性",
        "other": "その他",
        "unknown": "不明"
      },
      "notRecorded": "未記録"
    },
    "preferredContactMethod": {
      "label": "希望連絡方法",
      "values": {
        "phone": "電話",
        "mobile": "携帯電話",
        "email": "メール",
        "sms": "SMS"
      },
      "notSpecified": "未指定"
    },
    "validation": {
      "fullNameRequired": "氏名は必須です",
      "dateOfBirthRequired": "生年月日は必須です",
      "countryRequired": "国は必須です",
      "primaryLanguageRequired": "主言語は必須です",
      "invalidEmail": "メールアドレスが無効です",
      "nationalIdValidationFailed": "本人確認書類番号の検証に失敗しました：{{error}}",
      "invalidBirthTime": "出生時刻は HH:MM 形式で入力してください"
    },
    "organDonor": {
      "notRecorded": "未記録",
      "registered": "提供登録済み",
      "optedOut": "提供拒否",
      "notRegistered": "未登録",
      "unknown": "不明"
    }
  },
  "registration": {
    "title": "患者登録",
    "subtitle": "新規患者をシステムに登録します",
    "submit": "患者を登録",
    "submitting": "登録中...",
    "checkingDuplicates": "重複を確認中...",
    "registerNew": "新規患者登録",
    "registeredSuccess": "患者を正常に登録しました",
    "registerError": "患者の登録に失敗しました",
    "validationNationalIdFailed": "本人確認書類番号の検証に失敗しました：{{error}}",
    "sections": {
      "basicInformation": "基本情報",
      "identification": "本人確認",
      "contactInformation": "連絡先",
      "address": "住所",
      "languageAndCommunication": "言語とコミュニケーション",
      "additionalInformation": "その他の情報"
    },
    "fields": {
      "facility": "登録施設"
    },
    "placeholders": {
      "fullName": "例：Tan Wei Ming または 李小明",
      "alternativeName": "該当する場合はローマ字表記",
      "preferredName": "患者が希望する呼び名",
      "nationalIdNumberDefault": "本人確認書類番号を入力",
      "primaryPhone": "+81 90-1234-5678",
      "mobilePhone": "+81 90-1234-5678",
      "email": "patient@example.com",
      "facility": "施設を選択してください"
    },
    "helperText": {
      "fullName": "公式書類に記載のとおり氏名を入力してください",
      "facility": "この患者を登録する施設です。この施設のスタッフがカルテを開けるようになります。"
    },
    "flags": {
      "vipPatient": "VIP 患者",
      "medicalTourist": "医療渡航者"
    },
    "duplicate": {
      "title": "重複の可能性のある患者が見つかりました",
      "body": "以下の既存患者が入力情報と一致します：",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "一致度：{{score}}%（{{reasons}}）",
      "useExisting": "既存を使用",
      "createNew": "新規患者として登録",
      "restricted": {
        "title_one": "閲覧権限のない一致候補が {{count}} 件あります",
        "title_other": "閲覧権限のない一致候補が {{count}} 件あります",
        "body": "この患者は他の施設に既に診療記録がある可能性があります。新規作成の前に診療情報管理部門にご連絡ください。権限外の記録のため、詳細は表示されません。"
      },
      "overrideReasonLabel": "それでも登録する理由",
      "overrideReasonPlaceholder": "例：別人であることを患者に確認済み",
      "overrideReasonHelp": "この理由はあなたのアカウントに記録されます。同一人物に二重の記録を作るとカルテが分断されます。",
      "registerAnyway": "それでも登録する"
    }
  },
  "search": {
    "title": "患者検索",
    "subtitle": "患者記録を検索・管理します",
    "placeholder": "患者氏名、MRN、ID で検索...",
    "advancedFilters": "詳細フィルター",
    "filters": {
      "mrnPlaceholder": "例：P0000000001",
      "fullNamePlaceholder": "患者氏名",
      "phonePlaceholder": "電話番号",
      "emailPlaceholder": "メールアドレス"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "氏名",
      "dateOfBirth": "生年月日",
      "phone": "電話",
      "email": "メール",
      "country": "国",
      "status": "状態",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "すべて",
      "vipOnly": "VIP のみ",
      "nonVipOnly": "非 VIP のみ"
    },
    "statusFilter": {
      "all": "すべて",
      "active": "有効",
      "inactive": "無効"
    },
    "countryFilter": {
      "all": "すべての国"
    },
    "clearFilters": "フィルターをクリア",
    "dateOfBirthAria": "生年月日フィルター",
    "columns": {
      "mrn": "MRN",
      "fullName": "氏名",
      "dob": "DOB",
      "gender": "性別",
      "phone": "電話",
      "country": "国",
      "status": "状態"
    },
    "results": {
      "searching": "患者を検索中...",
      "loadError": "患者の読み込みに失敗しました。再度お試しください。",
      "retry": "再試行",
      "empty": "該当する患者が見つかりません。検索条件を変更してください。",
      "showing": "{{total}} 件中 {{from}} – {{to}} 件を表示"
    }
  },
  "myPatients": {
    "title": "担当患者",
    "subtitle": "担当している入院・外来患者の一覧",
    "searchPlaceholder": "氏名またはMRNで絞り込み...",
    "columns": {
      "mrn": "MRN",
      "patient": "氏名",
      "dob": "DOB",
      "sex": "性別",
      "class": "区分",
      "relationship": "関係",
      "admitted": "入院日時"
    },
    "kind": {
      "attending": "主治医",
      "careTeam": "ケアチーム",
      "referral": "紹介",
      "coverage": "カバー"
    },
    "restrictedBadge": "制限",
    "empty": {
      "title": "パネルに患者がいません",
      "body": "担当・カバー・紹介で関わる患者がここに表示されます。",
      "censusAction": "在院一覧を開く"
    },
    "results": {
      "searching": "担当患者を読み込み中...",
      "loadError": "担当患者の読み込みに失敗しました。再度お試しください。",
      "retry": "再試行",
      "showing": "{{total}} 件中 {{from}} – {{to}} 件を表示"
    }
  },
  "encounters": {
    "title": "受診歴",
    "create": "受診を作成",
    "filters": "フィルター",
    "filterLabels": {
      "status": "ステータス",
      "class": "区分",
      "fromDate": "開始日",
      "toDate": "終了日"
    },
    "filterPlaceholders": {
      "allStatuses": "すべてのステータス",
      "allClasses": "すべての区分"
    },
    "clearFilters": "フィルターをクリア",
    "fromDateAria": "開始日",
    "toDateAria": "終了日",
    "columns": {
      "encounterNumber": "受診番号",
      "class": "区分",
      "status": "ステータス",
      "admitDate": "入院日",
      "dischargeDate": "退院日",
      "location": "場所",
      "chiefComplaint": "主訴"
    },
    "locationLabel": "場所 #{{id}}",
    "loading": "受診歴を読み込み中...",
    "loadError": "受診歴の読み込みに失敗しました。",
    "empty": "この患者の受診歴はありません。",
    "showing": "{{total}} 件中 {{from}} – {{to}} 件を表示"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "本人確認書類の種類",
      "none": "なし",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "マイナンバー",
        "thaiNationalId": "タイ国民身分証"
      },
      "country": {
        "nric": "シンガポール",
        "hkid": "香港",
        "myKad": "マレーシア",
        "aadhaar": "インド",
        "ktp": "インドネシア",
        "myNumber": "日本",
        "thaiNationalId": "タイ"
      },
      "placeholderByType": {
        "nric": "例：S1234567D",
        "myKad": "例：850101-14-5678",
        "hkid": "例：A123456(3)",
        "aadhaar": "例：2341 2341 2346",
        "thaiNationalId": "例：1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "この番号のチェック文字が一致しません。患者の身分証明書で番号を確認してください。",
      "unavailable": "このID番号を確認できませんでした。患者の身分証明書で番号を確認してください。",
      "acknowledge": "身分証明書で番号を確認しました",
      "acknowledgeRequired": "保存する前に、身分証明書で番号を確認し、チェックを入れてください。"
    }
  },
  "country": {
    "values": {
      "sg": "シンガポール",
      "my": "マレーシア",
      "th": "タイ",
      "id": "インドネシア",
      "ph": "フィリピン",
      "vn": "ベトナム",
      "hk": "香港",
      "tw": "台湾",
      "jp": "日本",
      "kr": "韓国",
      "cn": "中国",
      "in": "インド",
      "au": "オーストラリア",
      "nz": "ニュージーランド"
    }
  },
  "language": {
    "values": {
      "en": "英語",
      "zh": "中国語（北京語）",
      "ms": "マレー語",
      "ta": "タミル語",
      "th": "タイ語",
      "id": "インドネシア語",
      "vi": "ベトナム語",
      "ja": "日本語",
      "ko": "韓国語",
      "hi": "ヒンディー語"
    }
  },
  "contact": {
    "addTitle": "連絡先を追加",
    "editTitle": "連絡先を編集",
    "name": "氏名",
    "relationship": {
      "label": "続柄",
      "selectPlaceholder": "選択してください...",
      "values": {
        "spouse": "配偶者",
        "parent": "親",
        "child": "子",
        "sibling": "兄弟姉妹",
        "guardian": "後見人",
        "friend": "友人",
        "other": "その他"
      }
    },
    "phone": "電話番号",
    "email": "メールアドレス",
    "emergencyContact": "緊急連絡先",
    "validation": {
      "nameRequired": "連絡先の氏名を入力してください",
      "relationshipRequired": "続柄を選択してください",
      "phoneRequired": "電話番号を入力してください",
      "invalidEmail": "メールアドレスの形式が正しくありません"
    },
    "savedSuccess": "連絡先を追加しました",
    "saveError": "連絡先の追加に失敗しました"
  },
  "immunization": {
    "addTitle": "予防接種を追加",
    "vaccineName": "ワクチン名",
    "vaccineNamePlaceholder": "例:インフルエンザ、新型コロナ (Pfizer)、B 型肝炎",
    "vaccineCode": "ワクチンコード (CVX)",
    "vaccineCodePlaceholder": "例:141",
    "administeredDate": "接種日",
    "lotNumber": "ロット番号",
    "lotNumberPlaceholder": "例:AB1234",
    "site": {
      "label": "接種部位",
      "selectPlaceholder": "部位を選択",
      "values": {
        "leftDeltoid": "左三角筋",
        "rightDeltoid": "右三角筋",
        "leftThigh": "左大腿",
        "rightThigh": "右大腿",
        "leftGluteal": "左臀部",
        "rightGluteal": "右臀部",
        "other": "その他"
      }
    },
    "route": {
      "label": "投与経路",
      "selectPlaceholder": "経路を選択",
      "values": {
        "intramuscular": "筋肉内注射 (IM)",
        "subcutaneous": "皮下注射 (SC)",
        "intradermal": "皮内注射 (ID)",
        "oral": "経口",
        "intranasal": "経鼻"
      }
    },
    "doseAmount": "用量",
    "doseAmountPlaceholder": "例:0.5 mL",
    "administeredBy": "接種者",
    "administeredByPlaceholder": "医療従事者の氏名または ID",
    "nextDueDate": "次回接種予定日",
    "notes": "備考",
    "notesPlaceholder": "追加の備考...",
    "validation": {
      "vaccineNameRequired": "ワクチン名を入力してください",
      "administeredDateRequired": "接種日を入力してください"
    },
    "savedSuccess": "予防接種記録を追加しました",
    "saveError": "予防接種記録の追加に失敗しました"
  },
  "insurance": {
    "addTitle": "保険プランを追加",
    "submitLabel": "保険を追加",
    "payerName": "保険会社名",
    "payerNamePlaceholder": "例:AIA シンガポール",
    "payerId": "保険会社 ID",
    "payerIdPlaceholder": "保険会社識別子",
    "planName": "プラン名",
    "planNamePlaceholder": "例:HealthShield Gold Max",
    "planType": {
      "label": "プラン種別",
      "selectPlaceholder": "種別を選択",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "公的",
        "private": "民間",
        "corporate": "団体",
        "other": "その他"
      }
    },
    "memberId": "被保険者番号",
    "memberIdPlaceholder": "被保険者番号",
    "policyNumber": "証券番号",
    "policyNumberPlaceholder": "証券番号を入力",
    "groupNumber": "団体番号",
    "groupNumberPlaceholder": "団体番号",
    "subscriberName": "契約者氏名",
    "subscriberNamePlaceholder": "患者と異なる場合に記入",
    "subscriberRelationship": {
      "label": "契約者との続柄",
      "values": {
        "self": "本人",
        "spouse": "配偶者",
        "child": "子",
        "parent": "親",
        "other": "その他"
      }
    },
    "priority": {
      "label": "優先順位",
      "values": {
        "primary": "第一",
        "secondary": "第二",
        "tertiary": "第三"
      }
    },
    "effectiveDate": "有効開始日",
    "terminationDate": "終了日",
    "copayAmount": "自己負担額 ($)",
    "coinsurancePercent": "自己負担割合 (%)",
    "deductibleAmount": "免責額 ($)",
    "outOfPocketMax": "自己負担上限額 ($)",
    "preAuthRequired": "事前承認が必要",
    "notes": "備考",
    "notesPlaceholder": "追加の備考...",
    "validation": {
      "payerNameRequired": "保険会社名を入力してください",
      "planNameRequired": "プラン名を入力してください",
      "memberIdRequired": "被保険者番号を入力してください",
      "effectiveDateRequired": "有効開始日を入力してください"
    },
    "savedSuccess": "保険プランを追加しました",
    "saveError": "保険プランの追加に失敗しました"
  },
  "problem": {
    "addTitle": "問題を追加",
    "problemName": "問題名",
    "problemNamePlaceholder": "例:2 型糖尿病",
    "icdCode": "ICD-10 コード",
    "icdSearchPlaceholder": "ICD-10 コードまたは説明を検索...",
    "onsetDate": "発症日",
    "severity": {
      "label": "重症度",
      "values": {
        "mild": "軽度",
        "moderate": "中等度",
        "severe": "重度"
      }
    },
    "notes": "備考",
    "notesPlaceholder": "追加の臨床備考...",
    "validation": {
      "problemNameRequired": "問題名を入力してください"
    },
    "savedSuccess": "問題リストに追加しました",
    "saveError": "問題の追加に失敗しました"
  },
  "accounts": {
    "pageTitle": "患者勘定",
    "backToDashboard": "ダッシュボード",
    "searchPatientLabel": "患者を検索",
    "searchPlaceholder": "氏名または MRN で検索...",
    "searching": "検索中...",
    "noPatientsFound": "患者が見つかりません",
    "loadingAccount": "勘定を読み込み中...",
    "mrnLabel": "MRN",
    "generateStatement": "明細書を作成",
    "statementComingSoon": "明細書作成機能は近日公開予定",
    "paymentPlan": "支払いプラン",
    "paymentPlanComingSoon": "支払いプラン設定は近日公開予定",
    "totalCharges": "請求合計",
    "totalPayments": "入金合計",
    "adjustments": "調整",
    "outstandingBalance": "未収残高",
    "transactionHistory": "取引履歴",
    "columns": {
      "date": "日付",
      "type": "種別",
      "description": "内容",
      "amount": "金額",
      "balance": "残高"
    },
    "transactionType": {
      "label": "種別",
      "values": {
        "charge": "請求",
        "payment": "入金",
        "adjustment": "調整"
      }
    },
    "loadingTransactions": "取引を読み込み中...",
    "noTransactionsFound": "取引が見つかりません",
    "emptyState": "患者を検索して勘定を表示してください"
  },
  "proxies": {
    "title": "代理人",
    "description": "この患者のポータルデータへのアクセスを認可された介護者、後見人、法定代理人です。取り消された記録は監査のため保持されます。",
    "addProxy": "代理人を追加",
    "newRelationshipHeading": "新規代理関係",
    "proxyUserId": "代理人ユーザー ID",
    "proxyUserIdPlaceholder": "ユーザー ID(管理 → ユーザーから)",
    "proxyUserIdHelper": "管理 → ユーザーで検索してください。ユーザー選択機能は後日提供予定です。",
    "relationship": {
      "label": "続柄",
      "values": {
        "parent": "親",
        "legalGuardian": "法定後見人",
        "spousePartner": "配偶者 / パートナー",
        "adultChild": "成人の子",
        "powerOfAttorney": "代理権受任者",
        "healthcareAgent": "医療代理人"
      }
    },
    "accessLevel": {
      "label": "アクセス権限",
      "values": {
        "full": "全権",
        "limited": "制限付き",
        "emergency": "緊急"
      },
      "descriptions": {
        "full": "ポータル全データ — 予約、検査結果、メッセージ、フォーム。",
        "limited": "予約とメッセージのみ(青少年向けの一般的な設定)。",
        "emergency": "患者が判断能力を失った際の医療代理人による緊急アクセス権限。"
      }
    },
    "startDate": "開始日",
    "endDate": "終了日",
    "startDateAria": "有効開始日",
    "endDateAria": "有効終了日",
    "grantAccess": "代理アクセスを付与",
    "userIdRequired": "代理人ユーザー ID が必要です",
    "createdSuccess": "代理関係を作成しました",
    "duplicateError": "この人物は既に同じ関係の代理人として登録されています",
    "invalidDataError": "代理データが無効です",
    "createError": "代理人の作成に失敗しました",
    "revokedSuccess": "代理アクセスを取り消しました",
    "revokeError": "代理人の取り消しに失敗しました",
    "emptyState": "代理人が設定されていません。上記のボタンから介護者、後見人、医療代理人にアクセスを付与してください。",
    "sections": {
      "active": "有効 ({{count}})",
      "plannedInactive": "予定 / 無効 ({{count}})",
      "revoked": "取消済 ({{count}})"
    },
    "userIdFallback": "ユーザー #{{id}}",
    "noEndDate": "(終了日なし)",
    "revokedOn": "{{date}} に取り消し",
    "revokeTitle": "代理アクセスを取り消す",
    "confirmRevokeTitle": "代理アクセスを取り消しますか?",
    "confirmRevokeBody": "{{name}} はこの患者のポータルデータへのアクセスを直ちに失います。記録は監査証跡に残ります。",
    "confirmRevokeLabel": "アクセスを取り消す"
  },
  "merge": {
    "title": "患者統合",
    "description": "重複した患者記録を統合します。元の患者は無効化され、すべての臨床データは対象(残存)患者に移動されます。",
    "sourceLabel": "元の患者(無効化されます)",
    "targetLabel": "対象患者(残存記録)",
    "clearSelection": "選択を解除",
    "searchPlaceholder": "氏名、MRN、電話番号で検索...",
    "fields": {
      "mrn": "MRN",
      "dob": "生年月日",
      "gender": "性別",
      "country": "国",
      "phone": "電話番号",
      "email": "メールアドレス"
    },
    "counts": {
      "encounters": "受診:{{count}}",
      "allergies": "アレルギー:{{count}}",
      "problems": "問題:{{count}}"
    },
    "samePatientWarning": "元の患者と対象患者は異なる必要があります。",
    "comparisonTitle": "人口統計比較",
    "comparisonSubtitle": "相違点はアンバー色でハイライト表示されます。",
    "columns": {
      "field": "項目",
      "source": "元 ({{mrn}})",
      "target": "対象 ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "氏名",
      "mrn": "MRN",
      "dateOfBirth": "生年月日",
      "gender": "性別",
      "phone": "電話番号",
      "email": "メールアドレス",
      "country": "国",
      "nationalId": "国民 ID"
    },
    "reasonLabel": "統合理由",
    "reasonPlaceholder": "これらの記録を統合する理由(必須)",
    "notesLabel": "備考(任意)",
    "notesPlaceholder": "この統合に関する追加の備考",
    "mergeButton": "患者を統合",
    "mergeSuccess": "患者を統合しました",
    "mergeError": "患者の統合に失敗しました",
    "successHeading": "統合が正常に完了しました。",
    "successBodyPrefix": "患者 {{mrn}} は無効化されました。すべての臨床データは ",
    "successBodySuffix": " に移動されました。",
    "confirmTitle": "患者統合の確認",
    "confirmBodyPrefix": "この操作は",
    "confirmBodyEmphasis": "取り消せません",
    "confirmBodySuffix": "。患者 {{sourceMrn}} ({{sourceName}}) は無効化され、すべての臨床データは患者 {{targetMrn}} ({{targetName}}) に移動されます。",
    "confirmButton": "患者を統合する",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "患者記録を読み込めませんでした。"
  },
  "allergy": {
    "addTitle": "アレルギーを追加",
    "editTitle": "アレルギーを編集",
    "allergen": "アレルゲン",
    "allergenPlaceholder": "例：ペニシリン、ピーナッツ",
    "type": "種類",
    "typeOptions": {
      "drug": "薬剤",
      "food": "食物",
      "environmental": "環境"
    },
    "severityLabel": "重症度",
    "severity": {
      "mild": "軽度",
      "moderate": "中等度",
      "severe": "重度",
      "lifeThreatening": "生命を脅かす"
    },
    "reaction": "反応",
    "reactionPlaceholder": "例：蕁麻疹、アナフィラキシー、悪心",
    "reactionOptions": {
      "rash": "発疹",
      "hives": "蕁麻疹",
      "anaphylaxis": "アナフィラキシー",
      "swelling": "腫脹",
      "itching": "そう痒",
      "other": "その他"
    },
    "onsetDate": "発症日",
    "notes": "備考",
    "notesPlaceholder": "追加の備考...",
    "verifiedBy": "確認者",
    "noKnownAllergies": "既知のアレルギーなし",
    "savedSuccess": "アレルギーを追加しました",
    "saveError": "アレルギーの追加に失敗しました",
    "deletedSuccess": "アレルギーを削除しました"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "ブレーデンスケール（褥瘡リスク）",
      "footer": "合計範囲：6-23。スコアが低いほど褥瘡発生のリスクが高くなります。",
      "scoreFormat": "スコア：{{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "非常に高リスク",
        "high": "高リスク",
        "moderate": "中等度リスク",
        "mild": "軽度リスク",
        "none": "リスクなし"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. 知覚認識",
          "options": {
            "1": "{{n}} - 完全に制限あり",
            "2": "{{n}} - 強度の制限あり",
            "3": "{{n}} - 軽度の制限あり",
            "4": "{{n}} - 障害なし"
          }
        },
        "moisture": {
          "label": "{{n}}. 湿潤",
          "options": {
            "1": "{{n}} - 常に湿潤",
            "2": "{{n}} - たいてい湿潤",
            "3": "{{n}} - 時々湿潤",
            "4": "{{n}} - めったに湿潤しない"
          }
        },
        "activity": {
          "label": "{{n}}. 活動性",
          "options": {
            "1": "{{n}} - 寝たきり",
            "2": "{{n}} - 座位可",
            "3": "{{n}} - 時々歩行可",
            "4": "{{n}} - 頻繁に歩行可"
          }
        },
        "mobility": {
          "label": "{{n}}. 可動性",
          "options": {
            "1": "{{n}} - 全く体動なし",
            "2": "{{n}} - 非常に限られる",
            "3": "{{n}} - 軽度の制限あり",
            "4": "{{n}} - 制限なし"
          }
        },
        "nutrition": {
          "label": "{{n}}. 栄養状態",
          "options": {
            "1": "{{n}} - 非常に不良",
            "2": "{{n}} - おそらく不適切",
            "3": "{{n}} - 良好",
            "4": "{{n}} - 非常に良好"
          }
        },
        "frictionShear": {
          "label": "{{n}}. 摩擦とずれ",
          "options": {
            "1": "{{n}} - 問題あり",
            "2": "{{n}} - 潜在的に問題あり",
            "3": "{{n}} - 明らかな問題なし"
          }
        }
      }
    },
    "morseFallScale": {
      "title": "モースフォールスケール",
      "scoreFormat": "スコア：{{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. 転倒歴",
          "options": {
            "0": "なし（{{score}}）",
            "25": "あり（{{score}}）"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. 副次的診断",
          "options": {
            "0": "なし（{{score}}）",
            "15": "あり（{{score}}）"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. 歩行補助具",
          "options": {
            "0": "なし／ベッド上安静／看護師介助（{{score}}）",
            "15": "松葉杖／杖／歩行器（{{score}}）",
            "30": "家具を支えにする（{{score}}）"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. 点滴／ヘパリンロック",
          "options": {
            "0": "なし（{{score}}）",
            "20": "あり（{{score}}）"
          }
        },
        "gait": {
          "label": "{{n}}. 歩行",
          "options": {
            "0": "正常／ベッド上安静／車椅子（{{score}}）",
            "10": "弱い（{{score}}）",
            "20": "障害あり（{{score}}）"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. 精神状態",
          "options": {
            "0": "自身の能力を正しく認識している（{{score}}）",
            "15": "能力を過大評価／制限を忘れる（{{score}}）"
          }
        }
      },
      "interventions": {
        "high": "高リスク介入：標準的な転倒予防策を実施する。患者に転倒リスクリストバンドを装着する。ベッドサイドに転倒リスク表示を掲示する。患者と家族への教育を行う。ベッドを最低位置に保ち、ブレーキをロックする。ナースコールが手の届く範囲にあることを確認する。滑り止め履物。トイレ誘導スケジュール。必要に応じて1対1の付き添いを検討する。",
        "moderate": "中リスク介入：標準的な転倒予防策を実施する。患者に転倒リスクリストバンドを装着する。患者と家族への教育を行う。ベッドを最低位置に保ち、ブレーキをロックする。ナースコールが手の届く範囲にあることを確認する。滑り止め履物。",
        "low": "低リスク介入：基本的な看護ケアを良好に行う。安全な移動について患者を教育する。環境とナースコールの使用方法をオリエンテーションする。"
      }
    }
  },
  "banner": {
    "label": "患者情報",
    "vip": "VIP",
    "vipTitle": "VIP 患者",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "歳",
    "sex": "性別",
    "codeStatusAria": "コードステータス：{{status}}",
    "isolationAria": "隔離：{{status}}",
    "isolation": {
      "contact": "接触感染",
      "droplet": "飛沫感染",
      "airborne": "空気感染",
      "none": "なし"
    },
    "fallRiskAria": "転倒リスク：{{level}}",
    "fallRisk": {
      "label": "転倒リスク",
      "low": "低",
      "moderate": "中",
      "high": "高"
    },
    "pressureInjuryRisk": "褥瘡リスク",
    "pressureInjuryRiskAria": "褥瘡リスク：{{level}}",
    "interpreter": "通訳",
    "interpreterRequired": "通訳が必要 — {{language}}",
    "languageNotSpecified": "言語未指定",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "アレルギー",
    "moreAllergies_one": "他 {{count}} 件",
    "moreAllergies_other": "他 {{count}} 件",
    "nkda": "NKDA",
    "allergiesUnknown": "アレルギー不明 — 読み込みに失敗しました"
  },
  "chartFrame": {
    "navAriaLabel": "患者カルテのナビゲーション",
    "tabs": {
      "summary": "サマリー",
      "encounters": "受診歴",
      "orders": "オーダー",
      "results": "検査結果",
      "medications": "投薬",
      "notes": "記録",
      "problems": "問題リスト",
      "allergies": "アレルギー",
      "immunizations": "予防接種",
      "intakeOutput": "I/O",
      "carePlans": "看護計画",
      "referrals": "紹介",
      "familyHistory": "家族歴",
      "socialHistory": "社会歴",
      "surgicalHistory": "手術歴",
      "advanceDirectives": "事前指示書",
      "insurance": "保険",
      "contacts": "連絡先",
      "proxies": "代理人",
      "identifiers": "識別番号",
      "addresses": "住所",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "デバイス",
      "ccdaImports": "C-CDAインポート"
    },
    "groups": {
      "clinical": "臨床",
      "history": "既往歴",
      "admin": "管理"
    },
    "breakGlass": {
      "auditBanner": "緊急アクセス — すべての操作が監査対象です。アクセスは 15 分後に期限切れとなります。",
      "dialogTitle": "制限付き患者記録",
      "dialogSubtitle": "緊急アクセス認証が必要です",
      "dialogBody": "この患者記録はアクセス制限付きです。アクセスするには理由を入力する必要があります。緊急アクセスはすべて記録され、監査されます。",
      "justificationLabel": "アクセス理由",
      "justificationPlaceholder": "この制限付き記録にアクセスする臨床上の理由を入力してください...",
      "justificationRequired": "緊急アクセスには理由の入力が必要です。",
      "requestError": "緊急アクセスの申請に失敗しました。再試行するか管理者にお問い合わせください。",
      "submitButton": "記録にアクセス",
      "submitting": "申請中...",
      "passwordLabel": "パスワードの確認",
      "passwordPlaceholder": "パスワードを再入力してください",
      "passwordRequired": "緊急アクセスにはパスワードの入力が必要です。",
      "passwordIncorrect": "パスワードが正しくありません。再試行してください。",
      "passwordHelp": "このワークステーションの操作者がご本人であることを確認します。",
      "totpLabel": "認証コード",
      "totpPlaceholder": "6桁のコード",
      "totpRequired": "緊急アクセスには認証アプリのコード入力が必要です。",
      "totpIncorrect": "コードが正しくありません。再試行してください。",
      "totpHelp": "このワークステーションの操作者がご本人であることを確認します。",
      "totpEnrollHint": "認証アプリが未登録です——緊急アクセスを利用するには、マイプロフィールで登録してください。"
    },
    "invalidId": {
      "title": "無効な患者 ID",
      "body": "指定された患者 ID は無効です。",
      "action": "患者を検索"
    },
    "notFound": {
      "title": "患者が見つかりません",
      "body": "患者データを読み込めません。患者が存在しないか、アクセス権限がない可能性があります。",
      "action": "患者を検索"
    },
    "loadError": {
      "title": "患者チャートを読み込めませんでした",
      "body": "チャートを読み込めませんでした。もう一度お試しください。",
      "action": "再試行"
    }
  },
  "address": {
    "title": "住所",
    "addAddress": "住所を追加",
    "newTitle": "新規住所",
    "editTitle": "住所を編集",
    "loading": "住所を読み込み中...",
    "loadError": "住所情報の読み込みに失敗しました。",
    "empty": "登録された住所はありません。",
    "addressType": {
      "label": "種別",
      "values": {
        "home": "自宅",
        "work": "勤務先",
        "temporary": "一時",
        "billing": "請求先"
      }
    },
    "fields": {
      "addressLine1": "住所 1 行目",
      "addressLine2": "住所 2 行目",
      "addressLine3": "住所 3 行目",
      "district": "区/郡",
      "city": "市",
      "stateProvince": "都道府県",
      "postalCode": "郵便番号",
      "country": "国"
    },
    "placeholders": {
      "addressLine1": "番地",
      "addressLine2": "建物名、号室",
      "addressLine3": "棟、街区",
      "district": "区/町村",
      "postalCode": "例:100-0001",
      "country": "例:JP"
    },
    "primaryBadge": "主たる住所",
    "setPrimary": "主たる住所として設定",
    "primaryHelper": "(他の住所の主たる住所指定は解除されます)",
    "fromLabel": "開始:{{date}}",
    "toLabel": "終了:{{date}}",
    "save": "保存",
    "update": "更新",
    "cancel": "キャンセル",
    "editTooltip": "住所を編集",
    "removeTooltip": "住所を削除",
    "addedSuccess": "住所を追加しました",
    "addError": "住所の追加に失敗しました",
    "updatedSuccess": "住所を更新しました",
    "updateError": "住所の更新に失敗しました",
    "removedSuccess": "住所を削除しました",
    "removeError": "住所の削除に失敗しました",
    "requiredError": "住所 1 行目と国は必須項目です",
    "confirmRemoveTitle": "住所を削除",
    "confirmRemoveMessage": "この{{type}}住所を削除してもよろしいですか?",
    "confirmRemoveLabel": "削除"
  },
  "allergies": {
    "pageTitle": "アレルギー",
    "addAllergy": "アレルギーを追加",
    "loading": "アレルギー情報を読み込み中...",
    "loadError": "アレルギー情報の読み込みに失敗しました。",
    "nka": {
      "title": "既知のアレルギーなし (NKA)",
      "body": "この患者のアレルギーは記録されていません。"
    },
    "sections": {
      "active": "活動性アレルギー ({{count}})",
      "inactive": "非活動性アレルギー ({{count}})"
    },
    "fields": {
      "reaction": "反応",
      "severity": "重症度",
      "onset": "発症",
      "recorded": "記録日"
    },
    "inactiveSummary": "反応:{{reaction}} | 重症度:{{severity}}",
    "deactivate": "非活動化",
    "deactivateTooltip": "アレルギーを非活動化",
    "deleteTooltip": "アレルギーを削除",
    "deactivatedSuccess": "アレルギーを非活動化しました",
    "deactivateError": "アレルギーの非活動化に失敗しました",
    "removedSuccess": "アレルギーを削除しました",
    "removeError": "アレルギーの削除に失敗しました",
    "confirmDeactivateTitle": "非活動化の確認",
    "confirmDeactivateMessage": "「{{name}}」を非活動化してもよろしいですか?",
    "confirmDeleteTitle": "削除の確認",
    "confirmDeleteMessage": "「{{name}}」を完全に削除してもよろしいですか?",
    "confirmLabel": "確認"
  },
  "problems": {
    "pageTitle": "問題リスト",
    "addProblem": "問題を追加",
    "loading": "問題リストを読み込み中...",
    "loadError": "問題リストの読み込みに失敗しました。",
    "tabs": {
      "active": "活動性 ({{count}})",
      "resolvedInactive": "解決済み/非活動性 ({{count}})"
    },
    "sortByLabel": "並び順:",
    "sortBy": {
      "onsetDate": "発症日",
      "severity": "重症度"
    },
    "status": {
      "label": "状態",
      "values": {
        "active": "活動性",
        "resolved": "解決済み",
        "inactive": "非活動性"
      }
    },
    "empty": {
      "active": "活動性の問題はありません。",
      "resolved": "解決済み又は非活動性の問題はありません。"
    },
    "fields": {
      "onset": "発症",
      "resolved": "解決"
    },
    "resolveButton": "解決",
    "reactivateButton": "再活動化",
    "resolveTooltip": "解決済みとして記録",
    "reactivateTooltip": "再活動化",
    "statusUpdatedSuccess": "問題の状態を更新しました",
    "statusUpdateError": "問題の状態の更新に失敗しました"
  },
  "immunizations": {
    "pageTitle": "予防接種",
    "addImmunization": "予防接種を追加",
    "loading": "予防接種記録を読み込み中...",
    "loadError": "予防接種記録の読み込みに失敗しました。",
    "empty": "予防接種記録が見つかりません。",
    "dueOverdue": "接種期限/期限切れ ({{count}})",
    "upcoming": "予定されている予防接種 ({{count}})",
    "dueLabel": "期限:{{date}}",
    "fromDateLabel": "開始日",
    "toDateLabel": "終了日",
    "fromDateAria": "予防接種 開始日",
    "toDateAria": "予防接種 終了日",
    "clearFilters": "クリア",
    "cvxLabel": "CVX:{{code}}",
    "columns": {
      "vaccine": "ワクチン",
      "date": "接種日",
      "lotNumber": "ロット番号",
      "site": "部位",
      "administeredBy": "実施者",
      "nextDue": "次回予定",
      "status": "状態"
    },
    "dueStatus": {
      "label": "状態",
      "values": {
        "overdue": "期限切れ",
        "dueToday": "本日期限",
        "upcoming": "予定"
      }
    }
  },
  "contacts": {
    "pageTitle": "連絡先",
    "addContact": "連絡先を追加",
    "loading": "連絡先を読み込み中...",
    "loadError": "連絡先情報の読み込みに失敗しました。",
    "empty": "登録された連絡先はありません。",
    "emergencyBadge": "緊急",
    "sections": {
      "emergency": "緊急連絡先 ({{count}})",
      "other": "その他の連絡先 ({{count}})"
    },
    "editTooltip": "連絡先を編集",
    "deleteTooltip": "連絡先を削除",
    "deletedSuccess": "連絡先を削除しました",
    "deleteError": "連絡先の削除に失敗しました",
    "confirmDeleteTitle": "連絡先を削除",
    "confirmDeleteMessage": "「{{name}}」を削除してもよろしいですか?",
    "confirmDeleteLabel": "削除"
  },
  "insurances": {
    "pageTitle": "保険",
    "addInsurance": "保険を追加",
    "loading": "保険情報を読み込み中...",
    "loadError": "保険情報の読み込みに失敗しました。",
    "empty": {
      "title": "保険プランなし",
      "body": "この患者の保険プランは記録されていません。"
    },
    "sections": {
      "active": "有効なプラン ({{count}})",
      "inactive": "無効なプラン ({{count}})"
    },
    "status": {
      "label": "状態",
      "values": {
        "active": "有効",
        "inactive": "無効",
        "pendingVerification": "確認待ち"
      }
    },
    "fields": {
      "memberId": "メンバー ID",
      "groupNumber": "団体番号",
      "effectiveDate": "発効日",
      "terminationDate": "終了日",
      "copay": "自己負担金",
      "coinsurance": "共済率",
      "deductible": "免責額",
      "subscriber": "契約者"
    },
    "preAuthBadge": "事前承認必要",
    "lastVerifiedLabel": "最終確認:{{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "確認",
    "verifyTooltip": "資格を確認",
    "editButton": "編集",
    "verifySuccess": "資格確認を開始しました",
    "verifyError": "資格確認に失敗しました"
  },
  "identifiersTab": {
    "pageTitle": "識別番号",
    "addIdentifier": "識別番号を追加",
    "loading": "識別番号を読み込み中...",
    "loadError": "識別番号情報の読み込みに失敗しました。",
    "empty": "登録された識別番号はありません。",
    "newTitle": "新規識別番号",
    "type": {
      "label": "種別",
      "selectPlaceholder": "種別を選択...",
      "values": {
        "externalMrn": "外部 MRN",
        "insuranceId": "保険番号",
        "studyId": "研究番号",
        "healthCard": "保険証",
        "nationalRegistry": "国民登録番号",
        "passport": "パスポート",
        "driverLicense": "運転免許証",
        "other": "その他"
      }
    },
    "fields": {
      "value": "番号",
      "assigningAuthority": "発行機関",
      "effectiveDate": "発効日",
      "expiryDate": "有効期限"
    },
    "placeholders": {
      "value": "例:123456789",
      "assigningAuthority": "例:厚生労働省"
    },
    "status": {
      "label": "状態",
      "values": {
        "active": "有効",
        "inactive": "無効"
      }
    },
    "columns": {
      "type": "種別",
      "value": "番号",
      "assigningAuthority": "発行機関",
      "effectiveDate": "発効日",
      "expiryDate": "有効期限",
      "status": "状態",
      "actions": "操作"
    },
    "save": "保存",
    "cancel": "キャンセル",
    "removeTooltip": "識別番号を削除",
    "addedSuccess": "識別番号を追加しました",
    "addError": "識別番号の追加に失敗しました",
    "removedSuccess": "識別番号を削除しました",
    "removeError": "識別番号の削除に失敗しました",
    "requiredError": "種別と番号は必須項目です",
    "confirmRemoveTitle": "識別番号を削除",
    "confirmRemoveMessage": "「{{type}}:{{value}}」を削除してもよろしいですか?",
    "confirmRemoveLabel": "削除"
  },
  "pages": {
    "advanceDirectives": {
      "title": "事前指示書",
      "addButton": "指示書を追加",
      "emptyState": "この患者の事前指示書は記録されていません。",
      "loading": "事前指示書を読み込み中...",
      "loadError": "事前指示書の読み込みに失敗しました。",
      "documentLink": "書類を表示",
      "effectivePrefix": "有効開始日:",
      "reviewPrefix": "見直し日:",
      "form": {
        "title": "新しい事前指示書",
        "labels": {
          "directiveType": "指示書の種類",
          "status": "ステータス",
          "effectiveDate": "有効開始日",
          "notes": "メモ",
          "optional": "任意"
        },
        "placeholders": {
          "notes": "指示書に関する補足メモ..."
        },
        "selectTypePlaceholder": "種類を選択してください...",
        "aria": {
          "effectiveDate": "有効開始日"
        },
        "buttons": {
          "save": "指示書を保存",
          "cancel": "キャンセル"
        }
      },
      "directiveType": {
        "DNR": "蘇生処置拒否(DNR)",
        "living-will": "リビング・ウィル",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "医療代理人",
        "power-of-attorney": "持続的代理権委任"
      },
      "directiveStatus": {
        "active": "有効",
        "inactive": "無効",
        "revoked": "撤回済み",
        "pending": "見直し待ち"
      },
      "toast": {
        "added": "事前指示書を追加しました",
        "addFailed": "事前指示書の追加に失敗しました",
        "directiveTypeRequired": "指示書の種類は必須です"
      }
    },
    "familyHistory": {
      "title": "家族歴",
      "addButton": "エントリーを追加",
      "emptyState": "この患者の家族歴は記録されていません。",
      "loading": "家族歴を読み込み中...",
      "loadError": "家族歴の読み込みに失敗しました。",
      "onsetAge": "発症年齢:{{age}}歳",
      "outcomePrefix": "転帰:",
      "form": {
        "title": "新しい家族歴エントリー",
        "labels": {
          "relationship": "続柄",
          "conditionName": "疾患名",
          "conditionCode": "疾患コード",
          "onsetAge": "発症年齢",
          "outcome": "転帰",
          "optional": "任意"
        },
        "placeholders": {
          "onsetAge": "年齢(歳)"
        },
        "selectRelationshipPlaceholder": "続柄を選択してください...",
        "selectOutcomePlaceholder": "転帰を選択してください...",
        "buttons": {
          "save": "エントリーを保存",
          "cancel": "キャンセル"
        }
      },
      "relationship": {
        "Mother": "母",
        "Father": "父",
        "Sibling": "兄弟姉妹",
        "Maternal Grandmother": "母方の祖母",
        "Maternal Grandfather": "母方の祖父",
        "Paternal Grandmother": "父方の祖母",
        "Paternal Grandfather": "父方の祖父",
        "Child": "子",
        "Aunt": "おば",
        "Uncle": "おじ"
      },
      "outcome": {
        "alive": "生存",
        "deceased": "死亡",
        "unknown": "不明"
      },
      "toast": {
        "added": "家族歴エントリーを追加しました",
        "addFailed": "家族歴エントリーの追加に失敗しました",
        "relationshipAndConditionRequired": "続柄と疾患名は必須項目です"
      }
    },
    "socialHistory": {
      "title": "社会歴",
      "editButton": "編集",
      "loading": "社会歴を読み込み中...",
      "loadError": "社会歴の読み込みに失敗しました。",
      "labels": {
        "smokingStatus": "喫煙状況",
        "alcoholUse": "飲酒",
        "substanceUse": "薬物使用",
        "housing": "居住状況",
        "employment": "就業状況",
        "safetyScreening": "安全スクリーニング",
        "notes": "メモ"
      },
      "placeholders": {
        "notes": "追加のメモ..."
      },
      "buttons": {
        "save": "変更を保存",
        "cancel": "キャンセル"
      },
      "toast": {
        "updated": "社会歴を更新しました",
        "updateFailed": "社会歴の更新に失敗しました"
      },
      "smokingStatus": {
        "never": "非喫煙者",
        "former": "元喫煙者",
        "currentDaily": "現喫煙者(毎日)",
        "currentOccasional": "現喫煙者(時々)",
        "unknown": "不明"
      },
      "alcoholUse": {
        "None": "なし",
        "Social/Occasional": "社交・時々",
        "Moderate": "中等度",
        "Heavy": "多量",
        "In Recovery": "回復期",
        "Unknown": "不明"
      },
      "substanceUse": {
        "None": "なし",
        "Current Use": "現在使用中",
        "Former Use": "過去に使用",
        "In Treatment": "治療中",
        "Unknown": "不明"
      },
      "housing": {
        "Stable": "安定",
        "Unstable": "不安定",
        "Homeless": "ホームレス",
        "Assisted Living": "介助付き住居",
        "Nursing Facility": "介護施設",
        "Unknown": "不明"
      },
      "employment": {
        "Employed Full-Time": "常勤雇用",
        "Employed Part-Time": "非常勤雇用",
        "Self-Employed": "自営業",
        "Unemployed": "無職",
        "Retired": "退職",
        "Student": "学生",
        "Disabled": "障害により就労不能",
        "Unknown": "不明"
      },
      "safetyScreening": {
        "No Concerns": "懸念なし",
        "Concerns Identified": "懸念あり",
        "Declined to Answer": "回答拒否",
        "Not Screened": "未スクリーニング"
      }
    },
    "surgicalHistory": {
      "title": "手術歴",
      "addButton": "手術を追加",
      "emptyState": "この患者の手術歴は記録されていません。",
      "loading": "手術歴を読み込み中...",
      "loadError": "手術歴の読み込みに失敗しました。",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "日付: {{date}}",
      "surgeonLabel": "執刀医: {{name}}",
      "anesthesiaLabel": "麻酔: {{type}}",
      "outcomePrefix": "経過:",
      "complicationsPrefix": "合併症:",
      "form": {
        "title": "新規手術歴エントリー",
        "labels": {
          "procedureName": "手術名",
          "procedureCode": "手術コード",
          "procedureCodeSuffix": "(CPT)",
          "date": "日付",
          "surgeonName": "執刀医",
          "anesthesiaType": "麻酔の種類",
          "laterality": "左右側",
          "outcome": "経過",
          "complications": "合併症"
        },
        "placeholders": {
          "surgeonName": "執刀医名",
          "complications": "合併症があれば..."
        },
        "selectPlaceholder": "選択...",
        "aria": {
          "procedureDate": "手術日"
        },
        "buttons": {
          "save": "エントリーを保存",
          "cancel": "キャンセル"
        }
      },
      "anesthesiaType": {
        "general": "全身麻酔",
        "regional": "区域麻酔",
        "local": "局所麻酔",
        "spinal": "脊椎麻酔",
        "epidural": "硬膜外麻酔",
        "sedation": "鎮静",
        "none": "なし",
        "unknown": "不明"
      },
      "laterality": {
        "left": "左",
        "right": "右",
        "bilateral": "両側"
      },
      "toast": {
        "added": "手術歴エントリーを追加しました",
        "addFailed": "手術歴エントリーの追加に失敗しました",
        "procedureNameRequired": "手術名は必須項目です"
      }
    },
    "referralManagement": {
      "title": "紹介",
      "addButton": "新規紹介",
      "refresh": "更新",
      "loading": "紹介を読み込み中...",
      "errorState": "紹介の読み込みに失敗しました。",
      "emptyState": "この患者の紹介記録はありません。",
      "emptyStateFiltered": "選択したステータスに該当する紹介はありません。",
      "ariaFilterStatus": "ステータスで紹介を絞り込む",
      "externalBadge": "外部",
      "filterStatus": {
        "allLabel": "全てのステータス"
      },
      "table": {
        "type": "種別",
        "reason": "理由",
        "specialty": "専門科",
        "priority": "優先度",
        "status": "ステータス",
        "requested": "申請日",
        "target": "目標日"
      },
      "form": {
        "title": "新規紹介",
        "labels": {
          "referralType": "紹介種別",
          "priority": "優先度",
          "specialty": "専門科",
          "reason": "理由",
          "targetDate": "目標日",
          "clinicalNotes": "臨床メモ",
          "optional": "任意"
        },
        "placeholders": {
          "reason": "紹介理由",
          "clinicalNotes": "追加の臨床メモ..."
        },
        "selectReferralTypePlaceholder": "種別を選択...",
        "selectSpecialtyPlaceholder": "専門科を選択...",
        "buttons": {
          "create": "紹介を作成",
          "cancel": "キャンセル"
        }
      },
      "referralType": {
        "consultation": "コンサルテーション",
        "transfer": "転院",
        "second-opinion": "セカンドオピニオン",
        "diagnostic": "診断",
        "therapeutic": "治療"
      },
      "priority": {
        "routine": "通常",
        "urgent": "緊急",
        "stat": "STAT"
      },
      "status": {
        "draft": "下書き",
        "submitted": "提出済み",
        "accepted": "受理済み",
        "scheduled": "予定済み",
        "completed": "完了",
        "cancelled": "キャンセル済み"
      },
      "toasts": {
        "createSuccess": "紹介を作成しました",
        "createFailed": "紹介の作成に失敗しました",
        "validationFailed": "紹介種別と理由は必須項目です"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored"
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "閲覧権限のない患者を含む組が {{count}} 件あります",
      "title_other": "閲覧権限のない患者を含む組が {{count}} 件あります",
      "body": "担当患者が他施設の記録と重複している可能性があります。判断には権限外の患者を閲覧する必要があるため一覧には表示されません。診療情報管理部門に確認を依頼してください。"
    }
  },
  "__review_duplicateReview": "Duplicate-review worklist copy — ships English pending market sign-off; 'merge' vs 'link' is a records-management register that differs by market.",
  "recordExport": {
    "button": "記録をエクスポート",
    "exporting": "エクスポート中…",
    "success": "記録をエクスポートしました",
    "failed": "エクスポートに失敗しました — 何もダウンロードされていません",
    "tooltip": "この患者の完全な診療記録をポータブルファイルとしてダウンロードします"
  },
  "device": {
    "addTitle": "植込みデバイスを記録",
    "editTitle": "抜去を記録",
    "deviceName": "デバイス名",
    "deviceNamePlaceholder": "例：Evera MRI ICD、薬剤溶出ステント",
    "deviceNameTooLong": "デバイス名は512文字以内で入力してください",
    "deviceType": "デバイスタイプ",
    "deviceTypePlaceholder": "例：ペースメーカー、ステント、人工関節",
    "udi": "UDI",
    "udiPlaceholder": "医療機器固有識別子",
    "deviceCode": "デバイスコード",
    "deviceCodeSystem": "コード体系",
    "deviceCodeSystemPlaceholder": "例：GMDN、SNOMED CT",
    "manufacturer": "製造元",
    "modelNumber": "モデル",
    "lotNumber": "ロット番号",
    "serialNumber": "シリアル番号",
    "implantDate": "植込み日",
    "explantDate": "抜去日",
    "status": "ステータス",
    "statusOptions": {
      "active": "使用中",
      "inactive": "不使用",
      "explanted": "抜去済み"
    },
    "mriSafety": "MRI安全性",
    "mriSafetyOptions": {
      "safe": "安全",
      "conditional": "条件付き",
      "unsafe": "危険",
      "unknown": "不明"
    },
    "notes": "備考",
    "notesPlaceholder": "追加の備考...",
    "savedSuccess": "デバイスを記録しました",
    "saveError": "デバイスの記録に失敗しました",
    "updatedSuccess": "抜去を記録しました",
    "updateError": "抜去の記録に失敗しました",
    "explantRequiresDate": "抜去済みのデバイスには抜去日が必要です",
    "explantBeforeImplant": "抜去日は植込み日より前にできません"
  },
  "devices": {
    "pageTitle": "植込みデバイス",
    "addDevice": "デバイスを記録",
    "loading": "デバイスを読み込み中...",
    "loadError": "デバイス情報の読み込みに失敗しました。",
    "empty": {
      "title": "植込みデバイスなし",
      "body": "この患者に記録されたデバイスはありません。"
    },
    "sections": {
      "active": "使用中のデバイス ({{count}})",
      "history": "抜去済み / 不使用 ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "製造元",
      "implanted": "植込み",
      "explanted": "抜去",
      "mriSafety": "MRI安全性",
      "recorded": "記録日"
    },
    "recordExplant": "抜去を記録",
    "explantTooltip": "このデバイスの抜去を記録",
    "removeTooltip": "エントリを削除",
    "removedSuccess": "デバイスエントリを削除しました",
    "removeError": "デバイスエントリの削除に失敗しました",
    "confirmDeleteTitle": "削除の確認",
    "confirmDeleteMessage": "「{{name}}」をリストから削除しますか？誤って記録したエントリのみ削除してください — 体内からの抜去の記録には「抜去を記録」を使用してください。",
    "confirmLabel": "確認"
  },
  "ccdaImports": {
    "title": "C-CDAインポート",
    "subtitle": "照合待ちの受信文書。インポートを開いて各エントリをカルテに取り込みます。",
    "empty": "この患者のインポート文書はありません。",
    "loadError": "インポートを読み込めませんでした。",
    "received": "受信",
    "docType": "種別",
    "status": "状態",
    "pending": "未処理",
    "entries": "件数",
    "match": "照合",
    "mismatch": "ID不一致",
    "statuses": {
      "pending": "未処理",
      "reviewed": "処理済み",
      "dismissed": "却下"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "紹介状",
      "discharge-summary": "退院サマリ",
      "other": "その他"
    }
  },
  "ccdaReview": {
    "title": "インポート #{{id}}",
    "back": "インポート一覧に戻る",
    "loadError": "このインポートを読み込めませんでした。",
    "mismatchWarning": "送信者のIDがこの患者と一致しません。受け入れる前に文書の帰属を確認してください。",
    "unnamed": "名称なし",
    "accept": "受入",
    "reject": "却下",
    "accepted": "カルテに取り込みました",
    "rejected": "エントリを却下しました",
    "alreadyReviewed": "他のユーザーが処理済み — 以下を更新しました",
    "reviewError": "処理に失敗しました",
    "confirmAcceptTitle": "カルテに取り込みますか?",
    "confirmAcceptMessage": "「{{name}}」がこの患者のカルテに追加されます。",
    "confirmRejectTitle": "このエントリを却下しますか?",
    "confirmRejectMessage": "「{{name}}」はキューから除外されます。原文書は保存されたままです。",
    "sections": {
      "problem": "問題",
      "medication": "薬剤",
      "allergy": "アレルギー"
    },
    "statuses": {
      "accepted": "受入済み",
      "rejected": "却下済み"
    }
  }
}
